// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/map-pin.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'map-pin',
  version: 'solid',
  paths: [
    {
      d: 'm11.628 22.7196.0036.0012C11.868 22.824 12 22.8 12 22.8s.132.024.3696-.0792l.0024-.0012.0072-.0036.0216-.0096a7 7 0 0 0 .3372-.168c.2232-.1152.5352-.288.9084-.5196.744-.4608 1.734-1.1592 2.7288-2.118C18.3624 17.9856 20.4 14.9916 20.4 10.8a8.4 8.4 0 1 0-16.8 0c0 4.1904 2.0376 7.1856 4.026 9.1008a16.48 16.48 0 0 0 2.7276 2.118 14.2 14.2 0 0 0 1.1712.6528l.0744.0348.0216.0096.0072.0036M12 13.5a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4',
      fillRule: 'evenodd',
    },
  ],
}
